// material-ui
import { useTheme } from "@mui/material/styles";
import { ThemeMode } from "config";

import iconDark from "assets/images/logo-toby-icon-dark.svg";
import icon from "assets/images/logo-toby-icon.svg";

const LOGO_ICON_WIDTH = 35;

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img
      src={theme.palette.mode === ThemeMode.DARK ? iconDark : icon}
      alt="TobyLabs"
      width={LOGO_ICON_WIDTH}
    />
  );
}
